// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

// slick
import $ from 'jquery';
import 'third/jquery.slick';

export default class AwardsSlider extends WebComponent {
  didMount() {
    const slider = $('.awards-slider__container');
    if (slider) {
      $(this.element).slick({
        mobileFirst: true,
        centerMode: true,
        centerPadding: '0',
        initialSlide: 1,
        infinite: true,
        arrows: true,
        dots: false,
        touchThreshold: 10,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 500,
        prevArrow: '<span class="awards-slider__arrow awards-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#arrow-left"></use></svg></span>',
        nextArrow: '<span class="awards-slider__arrow awards-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#arrow-right"></use></svg></span>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      });
    }
    // eslint-disable-next-line no-undef
    $(window).resize(() => {
      $(slider)[0].slick.refresh();
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/AwardsSlider.js